/**
 * Design Check shell — its own branded chrome, deliberately separate from the
 * portal Navbar so invited clients never see internal navigation.
 */

import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './DesignCheck.css';
import ThemeToggle from '../../components/layout/ThemeToggle';

function DesignCheckLayout({ children }) {
  const [me, setMe] = useState(null);
  const role = localStorage.getItem('userRole');
  const isClient = role === 'client';
  const isStaff = role === 'admin' || role === 'sales';

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) return;
    fetch('/api/design-check/me', { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((data) => { if (data.success) setMe(data); })
      .catch(() => {});
  }, []);

  const signOut = async () => {
    const token = localStorage.getItem('authToken');
    try {
      await fetch('/api/auth/logout', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (e) { /* best effort */ }
    localStorage.removeItem('authToken');
    localStorage.removeItem('tokenExpiry');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userRole');
    window.location.href = isClient ? '/design-check/goodbye' : '/';
  };

  const invite = me && me.invite;
  const daysLeft = invite ? Math.max(0, Math.ceil((invite.expiresAt - Date.now()) / 86400000)) : null;

  return (
    <div className="dc-shell">
      <header className="dc-header">
        <Link to="/design-check" className="dc-brand">
          <span className="dc-brand-mark">
            <img src="/images/favicon.png" alt="Rapid Fusion" />
          </span>
          <span className="dc-brand-text">
            <strong>Rapid Fusion</strong>
            <span>Design Check</span>
          </span>
        </Link>
        <nav className="dc-nav">
          <NavLink to="/design-check" end>My parts</NavLink>
          <NavLink to="/design-check/chat">Ask Bob</NavLink>
          <NavLink to="/design-check/guide">Design guide</NavLink>
          {isStaff && <NavLink to="/design-check/invites">Client invites</NavLink>}
          {!isClient && <Link to="/">← Portal</Link>}
          {invite && (
            <span className={`dc-invite-chip ${daysLeft <= 3 ? 'expiring' : ''}`}>
              {invite.label} · {daysLeft} day{daysLeft === 1 ? '' : 's'} left
            </span>
          )}
          <ThemeToggle />
          <button className="dc-navlink" onClick={signOut}>Sign out</button>
        </nav>
      </header>
      <main className="dc-main">{children}</main>
      <footer className="dc-footer">
        Rapid Fusion — large-format robotic 3D printing · Design guidance powered by Bob AI ·
        Guide content: More Than Layers design guide
      </footer>
    </div>
  );
}

export default DesignCheckLayout;
